// import { sortableElement } from 'react-sortable-hoc';

import React, { useRef, useEffect, useState } from 'react';
import { Row, Col } from 'antd';
import { Animations } from 'appkit-react/lib/Animations';
import _ from 'lodash';
import Card from './card';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
// import { NoData } from '@components';

const hasSame =
  (field) =>
  (cardA = {}, cardB = {}) =>
    cardB[field] === cardA[field];

const isSame = (a, b) =>
  hasSame('id')(a, b) || (typeof a === 'undefined' && typeof b === 'undefined');

const getDeletedCard = (prev, cur) => {
  if (!prev || !cur) {
    return null;
  }
  let i = 0,
    j = 0,
    res = null;

  while (i < prev.length || j < cur.length) {
    if (isSame(prev[i], cur[j])) {
      i++;
      j++;
    } else {
      res = i;
      break;
    }
  }
  return res;
};

const NO_CARDS = () => (
  <div
    style={{
      lineHeight: '14.125rem',
      textAlign: 'center',
      fontSize: '1.125rem',
      color: '#7d7d7d',
    }}
  >
    <div className="no-data">
      Add deal insights throughout M&A Gateway and review them here
    </div>
  </div>
);

// Replacement for sortableElement using @dnd-kit
const SortableCards = ({
  value: { title, content, cate, action, insight, sectionCommentProps, id },
  sortIndex,
  collection,
  disabled,
  effect,
  afterAnimation,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: `${collection}-${sortIndex}`,
    disabled,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <li
      className="sortable-item"
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
    >
      <Card
        title={title}
        content={content}
        cate={cate}
        action={action}
        insight={insight}
        effect={effect}
        afterAnimation={afterAnimation}
        sectionCommentProps={sectionCommentProps}
        index={sortIndex}
        useRichText={false}
      />
    </li>
  );
};

function CardsWithAnimLayout({ cardsData, collection, disabled }) {
  const cardsRef = useRef(null);
  const [cardsMeta, setCardsMeta] = useState(cardsData);
  const [updatedIdxs, setUpdatedIdxs] = useState({
    deletedCard: null,
    newCard: null,
  });

  const isPropagaedByPrev =
    _.differenceBy(cardsData, cardsRef.current, 'id').length === 1;

  const hasDeleted =
    cardsRef.current != null &&
    cardsData.length === cardsRef.current.length - 1 &&
    isPropagaedByPrev;

  const hasCreated =
    cardsRef.current != null &&
    cardsData.length === cardsRef.current.length + 1 &&
    isPropagaedByPrev;

  useEffect(() => {
    if (hasDeleted) {
      setUpdatedIdxs({
        deletedCard: getDeletedCard(cardsRef.current, cardsData),
      });
    } else if (hasCreated) {
      setCardsMeta([cardsData[0], ...cardsRef.current]);
      setUpdatedIdxs({ newCard: 0 });
    } else {
      rebaseCards();
    }
  }, [cardsData]);

  const mapCardEffectToUpdatedCard = (i) => {
    if (i === updatedIdxs.deletedCard) {
      return 'fadeOutUp';
    }
    if (i === updatedIdxs.newCard) {
      return 'fadeInDown';
    }
    return null;
  };

  const rebaseCards = () => {
    setUpdatedIdxs({ deletedCard: null, newCard: null });
    cardsRef.current = cardsData;
    setCardsMeta([...cardsData]);
  };

  return (
    <div style={{ overflow: 'hidden' }}>
      <Animations effect="fadeInRight" active={true}>
        <ul className="sortable-list">
          {cardsMeta.map((value, index) => (
            <SortableCards
              key={`item-${value.id || index}`}
              value={value}
              collection={collection}
              disabled={disabled}
              sortIndex={index}
              effect={mapCardEffectToUpdatedCard(index)}
              afterAnimation={rebaseCards}
            />
          ))}
        </ul>
      </Animations>
    </div>
  );
}

function CardsWithLayout({ cardsData }) {
  const cards = cardsData.map((c, i) => (
    <Card key={i} action={c.action} title={c.title} content={c.content}>
      {c.cate}
    </Card>
  ));

  return (
    <Row span={24} gutter={[40, 40]}>
      {cards.map((e, i) => (
        <Col key={i} span={8}>
          {e}
        </Col>
      ))}
    </Row>
  );
}
export default function ({
  cardsData,
  animActive = false,
  collection,
  ...rest
}) {
  if (cardsData.length === 0) {
    return <NO_CARDS />;
  }

  if (animActive) {
    return CardsWithAnimLayout({ cardsData, collection, ...rest });
  }
  return CardsWithLayout({ cardsData });
}
